/**
 * FinalGateDecision — hosts the binding FR-077 activation decision on the
 * Final gate tab. Reuses HumanReviewTab / ReviewDecisionForm verbatim (same
 * POST /api/v1/jobs/{id}/review endpoint + enforcement); only the mount
 * location moves here from the standalone review tab.
 *
 * The report only exists once the pipeline has synthesised a gate report
 * (completed/failed jobs). Until then we show a placeholder so the binding
 * form never appears — mirroring JobDetailPage's `showReport` gate.
 */
import { HumanReviewTab } from '@/pages/jobs/review';
import type { Job, GateReport } from '@/types';

interface Props {
  job: Job | null;
  report: GateReport | null;
}

export function FinalGateDecision({ job, report }: Props) {
  if (!job || !report) {
    return (
      <div className="rounded border border-dashed bg-muted/30 p-4 text-sm text-muted-foreground">
        The final synthesis isn't available yet — the gate stage hasn't
        completed for this contract. The binding approve / reject decision
        appears here once the pipeline finishes.
      </div>
    );
  }
  return <HumanReviewTab job={job} report={report} />;
}
